import Highcharts from 'highcharts';

const verticalLabels: Record<string, Highcharts.SVGElement> = {};

interface RenderLineOpts {
  chart: Highcharts.Chart;
  point: Highcharts.Point & { plotX?: number; plotY?: number };
  id: string;
  color: string;
  offset?: number;
}

export const renderVerticalLineWithSquare = ({
  chart,
  point,
  id,
  color,
  offset = 0,
}: RenderLineOpts) => {
  if (verticalLabels[id]) {
    verticalLabels[id].destroy();
  }

  verticalLabels[id] = chart.renderer
    .g(id)
    .attr({ zIndex: 3 })
    .add();

  verticalLabels[id].element.setAttribute('aria-hidden', 'true');

  const x = chart.plotLeft + (point.plotX || 0);
  const plotY = point.plotY || 0;

  let dynamicOffset = offset;

  if (plotY === 100) {
    dynamicOffset = -offset;
  } else if (plotY === 0) {
    dynamicOffset = offset;
  }

  const fromY = chart.plotTop + plotY - dynamicOffset;
  const toY = chart.plotHeight + chart.plotTop;

  chart.renderer
    .rect(x - 5, fromY, 10, 10)
    .attr({ fill: color })
    .add(verticalLabels[id]);

  chart.renderer
    .path(
      chart.renderer.crispLine(
        [
          ['M', x, fromY],
          ['L', x, toY],
        ],
        1,
        'round',
      ),
    )
    .attr({
      stroke: color,
      'stroke-width': 2,
      'stroke-dasharray': '7 3',
    })
    .add(verticalLabels[id]);
};
